<template lang="pug">
b-modal#addMiniGameTemplate(
  ref="addMiniGameTemplate"
  :title="$t('ui.combine.add_mini_game_template')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.template')").mb-1
      DefaultTemplateLookup(
        ref="template_code"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.template_code.$dirty"
        :error="$v.template_code.$error"
        v-model.trim.lazy="$v.template_code.$model"
      )
      ValidateResult(:value="$v.template_code" :name="$t('ui.template')")
    b-form-group(:label="$t('ui.status')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="is_enable")
        span.custom-switch-indicator

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import DefaultTemplateLookup from "@/library/DefaultTemplateLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DefaultTemplateLookup
  },
  props: {
    item: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      template_code: '',
      is_enable: true,
    };
  },
  validations: {
    template_code: {
      required
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addMiniGameTemplateUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          game_id: this.item,
          template_code: this.template_code,
          enable: this.is_enable
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.add_mini_game_template", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.addMiniGameTemplate.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.addMiniGameTemplate.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.template_code = "";
      this.is_enable = true;
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.template_code = "";
      this.is_enable = true;
      this.$refs.template_code.$el.focus();
    }
  }
};
</script>
